<ol class="breadcrumb float-xl-right">
  <li class="breadcrumb-item">Inicio</li>
  <li class="breadcrumb-item">Administración</li>
  <li class="breadcrumb-item active">Menús por Rol</li>
</ol>

<h1 class="page-header"><i class="fas fa-bars"></i> Administración de Menús<small> Asignación por Rol</small></h1>

<div class="scrollable">
  <panel [noButton]="true">
    <div class="row mb-4">
      <div class="col-md-5">
        <label class="form-label fw-600">Seleccionar Rol</label>
        <ng-select [items]="roles" bindLabel="name" bindValue="id" [clearable]="false"
          [(ngModel)]="roleSelected" (change)="onRoleChange()" placeholder="Seleccione un rol...">
          <ng-template ng-label-tmp let-item="item">
            <i class="fas fa-user-shield me-2"></i>{{ item.name }}
          </ng-template>
        </ng-select>
      </div>
      <div class="col-md-7 d-flex align-items-end justify-content-end gap-2">
        <button class="btn btn-success btn-xs" (click)="open(modalMenu)">
          <i class="fas fa-plus me-1"></i> Nuevo Menú
        </button>
      </div>
    </div>

    @if (!roleSelected) {
      <div class="text-center py-5 text-muted">
        <i class="fas fa-hand-pointer fs-1 mb-3 d-block"></i>
        <span>Seleccione un rol para gestionar sus menús</span>
      </div>
    }

    @if (roleSelected && menus.length === 0) {
      <div class="text-center py-5 text-muted">
        <i class="fas fa-menu fs-1 mb-3 d-block"></i>
        <span>No hay menús asignados a este rol</span>
        <div class="mt-3">
          <button class="btn btn-outline-primary btn-xs" (click)="open(modalMenu)">
            <i class="fas fa-plus me-1"></i> Crear primer menú
          </button>
        </div>
      </div>
    }

    @if (roleSelected && menus.length > 0) {
      <div class="menu-tree">
        @for(menu of menus; track menu.id; let im = $index){
          <div class="menu-node menu-parent">
            <div class="menu-row">
              <div class="menu-info">
                @if (menu.icon) {
                  <i class="{{ menu.icon }} fa-fw menu-icon"></i>
                } @else {
                  <i class="fas fa-fw fa-link menu-icon text-muted"></i>
                }
                <span class="menu-title">{{ menu.title }}</span>
                @if (menu.url) {
                  <code class="menu-url">/{{ menu.url }}</code>
                }
              </div>

              <div class="menu-actions">
                <button class="btn btn-xs btn-ghost" (click)="moveUp(menu, im)" [disabled]="im === 0"
                  ngbTooltip="Subir">
                  <i class="fas fa-chevron-up"></i>
                </button>
                <button class="btn btn-xs btn-ghost" (click)="moveDown(menu, im)" [disabled]="im === menus.length - 1"
                  ngbTooltip="Bajar">
                  <i class="fas fa-chevron-down"></i>
                </button>
                @if (menu.enabled) {
                  <i class="fas fa-check-circle status-icon enabled" (click)="toggleMenuRole(menu, false)" ngbTooltip="Habilitado — click para deshabilitar"></i>
                } @else {
                  <i class="fas fa-times-circle status-icon disabled" (click)="toggleMenuRole(menu, true)" ngbTooltip="Deshabilitado — click para habilitar"></i>
                }
                <button class="btn btn-xs btn-ghost text-primary" (click)="open(modalMenu, menu)" ngbTooltip="Editar">
                  <i class="fas fa-edit"></i>
                </button>
              </div>
            </div>

            @if (menu.submenu && menu.submenu.length > 0) {
              <div class="menu-children">
                @for(sub of menu.submenu; track sub.id; let is = $index){
                  <div class="menu-node menu-sub">
                    <div class="menu-row">
                      <div class="menu-info">
                        <i class="fas fa-angle-right fa-fw menu-icon text-info"></i>
                        <span>{{ sub.title }}</span>
                        @if (sub.url) {
                          <code class="menu-url">/{{ sub.url }}</code>
                        }
                      </div>

                      <div class="menu-actions">
                        <button class="btn btn-xs btn-ghost" (click)="moveSubUp(menu, sub, is)" [disabled]="is === 0"
                          ngbTooltip="Subir">
                          <i class="fas fa-chevron-up"></i>
                        </button>
                        <button class="btn btn-xs btn-ghost" (click)="moveSubDown(menu, sub, is)" [disabled]="is === menu.submenu.length - 1"
                          ngbTooltip="Bajar">
                          <i class="fas fa-chevron-down"></i>
                        </button>
                        @if (sub.enabled) {
                          <i class="fas fa-check-circle status-icon enabled" (click)="toggleMenuRole(sub, false)" ngbTooltip="Habilitado — click para deshabilitar"></i>
                        } @else {
                          <i class="fas fa-times-circle status-icon disabled" (click)="toggleMenuRole(sub, true)" ngbTooltip="Deshabilitado — click para habilitar"></i>
                        }
                        <button class="btn btn-xs btn-ghost text-primary" (click)="open(modalMenu, sub)" ngbTooltip="Editar">
                          <i class="fas fa-edit"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </panel>
</div>

<ng-template #modalMenu let-c="close" let-d="dismiss">
  <div class="modal-header">
    <span class="fs-3 fw-700">
      <i class="fas fa-bars me-2"></i>{{ menuForm.value.id ? 'Editar Menú' : 'Nuevo Menú' }}
    </span>
  </div>
  <div class="modal-body" [formGroup]="menuForm">
    <div class="row g-3">
      <div class="col-md-6">
        <label class="form-label fw-600">Título <span class="text-danger">*</span></label>
        <input type="text" class="form-control" placeholder="Ej: Gestión de Usuarios" formControlName="title" />
      </div>
      <div class="col-md-6">
        <label class="form-label fw-600">Submenú de</label>
        <ng-select [items]="menus" placeholder="Ninguno (menú raíz)" bindLabel="title" bindValue="id"
          formControlName="parentId" [clearable]="true" appendTo="body" dropdownPosition="auto">
        </ng-select>
      </div>
      <div class="col-md-6">
        <label class="form-label fw-600">Icono (FontAwesome)</label>
        <div class="input-group">
          @if (menuForm.value.icon) {
            <span class="input-group-text"><i class="{{ menuForm.value.icon }}"></i></span>
          }
          <input type="text" class="form-control" placeholder="fas fa-users" formControlName="icon" />
        </div>
        <div class="small text-muted mt-1">Ej: fas fa-users, fas fa-cog, fas fa-file-alt</div>
      </div>
      <div class="col-md-6">
        <label class="form-label fw-600">URL</label>
        <input type="text" class="form-control" placeholder="Ej: admin/usuarios" formControlName="url" />
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-outline-secondary" (click)="d('Cross click')">
      <i class="fas fa-times me-1"></i> Cancelar
    </button>
    <button class="btn btn-primary" [disabled]="menuForm.invalid" (click)="d('Cross click'); saveMenu()">
      <i class="fas fa-save me-1"></i> Guardar
    </button>
  </div>
</ng-template>
